module.exports = __webpack_public_path__ + "static/media/remove-close.1fd26d06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/remove-close.svg
// module id = 348
// module chunks = 1